import React, { Component } from 'react';
import BanterHeading from "../elements/BanterHeading";
import globals from "../globals";

class Cubes extends Component {

	componentDidMount() {
		this.controller = globals.genericAnimation(this);
	}

	componentWillUnmount() {
		globals.destroy(this.controller);
	}

	render() {
		const Cubes = this.props.items.map((value, key) => {
			return (
				<div className="cube" key={key}>
					<BanterHeading
						title={value.title}
						align={(key === 0 || key === 2 ? 'right' : 'left')}
						theme={(key === 1 || key === 2 ? 'light' : 'dark')}
					/>
					{value.copy.map((copy, i) => {
						return (
							<p key={i} dangerouslySetInnerHTML={{__html: copy}} />
						);
					})}
				</div>
			);
		});

		return (
			<div className="row cubes-module">
				<div className="col-xs-12 col-md-10 col-md-offset-1 centered">
					<h1 dangerouslySetInnerHTML={{__html: this.props.title}} />
					<h4>{this.props.subTitle}</h4>
					<div className="cubes">
						{Cubes}
					</div>
				</div>
			</div>
		);	
	}

}

export default Cubes;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/Cubes.js